import produce from 'immer';
import { actionTypes } from '../actions/modalActions';
import { StorageKeys } from '../constants';

import { setObjectData, getObjectData } from '../utils/localStorageHelper';

const initialState = getObjectData(StorageKeys.modalState) || {};

const RestaurantReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.TOGGLE_MODAL: {
                draft[action.payload.modal] = action.payload.isOpen;
                setObjectData(StorageKeys.modalState, draft);
                break;
            }
            default:
                return state
        }
    })

export default RestaurantReducer
